module.exports = __webpack_public_path__ + "media/step_5_da.6b7b8771.mp3";